import { FormikValues } from 'formik';
import axios from 'axios'
import { ActivityStatus, MemberEnrollmentUpdateInput, MemberEnrollmentUpdateReason } from "../../generated/graphql";
import { ApolloClient } from "@apollo/client";
import { CREATE_OR_UPDATE_MEMBER_MUTATION, FIND_MEMBER_ACTIVITY_QUERY, INTAKE_MUTATION, UPDATE_MEMBER_ADDRESS } from "../../Queries";
import { Party } from "../enums/Party";
import { getKeyByValue } from "../enums/KeyFinder";
import { Gender } from "../enums/Gender";
import { PayFrequency } from "../enums/PayFrequency";

export async function sendIntake(values: FormikValues, apolloClient: ApolloClient<any>): Promise<string> {
    const authorization = axios.defaults.headers.common['Authorization'];
    if(authorization && [Party.EMPLOYEE, Party.EMPLOYER].includes(values.party)) {
        await updateMember(values, apolloClient)
    }
    return (await apolloClient.mutate({
        mutation: INTAKE_MUTATION,
        variables: {
            intakeInput: values
        }
    }))?.data?.intake?.claimNumber
}

async function updateMember(values: FormikValues, apolloClient: ApolloClient<any>) {
    try {
        let updatedEnrollment = await (values.party === Party.EMPLOYER ? createOrUpdateMember(values, apolloClient) : updateMemberAddress(values, apolloClient))
        const enrollmentStatusId = updatedEnrollment?.id;
        if (!enrollmentStatusId) {
            return
        }
        let enrollmentChecks = 0;
        while (enrollmentChecks < 50
        && ![ActivityStatus.Pending, ActivityStatus.Completed, ActivityStatus.NoChangesRequired, ActivityStatus.Failed].includes(updatedEnrollment?.status)) {
            updatedEnrollment = (await apolloClient.query({
                query: FIND_MEMBER_ACTIVITY_QUERY,
                variables: {
                    activityId: enrollmentStatusId
                },
                fetchPolicy: 'no-cache'
            }))?.data?.findMemberActivity
            await new Promise((r) => setTimeout(r, 1000))
            enrollmentChecks++;
        }
    } catch (e) {
        console.log(e)
    }
}

async function createOrUpdateMember(values: FormikValues, apolloClient: ApolloClient<any>) {
    if(process.env.REACT_APP_SELF_ACCOUNTING_MEMBER_BUILD_TOGGLE !== 'true') {
        return;
    }
    return (await apolloClient.mutate({
        mutation: CREATE_OR_UPDATE_MEMBER_MUTATION,
        variables: {
            memberEnrollmentUpdateInput: {
                policyId: values.policyNumber,
                firstName: values.firstName,
                lastName: values.lastName,
                dateOfBirth: values.dateOfBirth,
                gender: getKeyByValue(Gender, values.gender),
                address: {
                    lineOne: values.streetAddress,
                    city: values.city,
                    stateAbbreviation: values.state,
                    zip: values.zipCode
                },
                employmentInformation: {
                    employerName: values.employerName,
                    memberGroupName: values.memberGroupName,
                    billGroupName: values.unitName,
                    dateOfHire: values.dateOfHire
                },
                underwritingInformation: {
                    wage: parseFloat(values.baseWage),
                    wageFrequency: getKeyByValue(PayFrequency, values.baseWageFrequency)
                },
                enrollmentReason: MemberEnrollmentUpdateReason.Other,
                enrollmentReasonDateOfEvent: '',
                ssn: values.socialSecurityNumber?.replaceAll('-', '')
            } as MemberEnrollmentUpdateInput
        }
    }))?.data?.createOrUpdateMember;
}

async function updateMemberAddress(values: FormikValues, apolloClient: ApolloClient<any>) {
    return (await apolloClient.mutate({
        mutation: UPDATE_MEMBER_ADDRESS,
        variables: {
            memberAddressInput: {
                lineOne: values.streetAddress,
                city: values.city,
                stateAbbreviation: values.state,
                zip: values.zipCode
            }
        }
    }))?.data?.updateMemberAddress;
}
